import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";

const AboutHeroSection = () => {
  const handleGetStarted = () => {
    console.log("Get Started clicked");
  };

  const handleWatchDemo = () => {
    console.log("Watch Demo clicked");
  };

  return (
    <Box
      sx={{
        backgroundImage: `url(${require("assets/images/footer.png")})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        position: "relative",
        display: "flex",
        alignItems: "center",
        py: { xs: 3, sm: 4, md: 10 },
      }}
    >
      {/* Dark Overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          zIndex: 1,
        }}
      />

      <Container maxWidth="xl" sx={{ position: "relative", zIndex: 2 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            minHeight: { xs: "40vh", sm: "45vh", md: "50vh" },
            gap: { xs: 3, sm: 4, md: 6 },
          }}
        >
          {/* Left Section - Text Content */}
          <Box sx={{ flex: 1, maxWidth: "600px" }}>
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: "2.5rem", md: "3.5rem", lg: "4rem" },
                fontWeight: 700,
                fontFamily: "Outfit",
                mb: 4,
                color: "#FFFFFF",
                lineHeight: 1.2,
              }}
            >
              Grow Your Nutrition Practice with Smart Automation
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: "1.1rem", md: "1.3rem" },
                fontWeight: 400,
                fontFamily: "Outfit",
                color: "rgba(255, 255, 255, 0.9)",
                lineHeight: 1.6,
                mb: 6,
              }}
            >
              Streamline scheduling, automate payments, and manage clients all
              from one beautifully simple dashboard.
            </Typography>

            {/* Call to Action Buttons */}
            {/* <Box sx={{ display: "flex", gap: 3, mb: 4, flexDirection: { xs: "column", sm: "row" } }}>
              <Button
                onClick={handleGetStarted}
                sx={{
                  backgroundColor: "#000000",
                  color: "#5BF2FF",
                  fontWeight: 600,
                  borderRadius: "10px",
                  textTransform: "none",
                  padding: "12px 32px",
                  fontSize: "1rem",
                  fontFamily: "Outfit",
                  border: "1px solid rgba(255, 255, 255, 0.3)",
                  "&:hover": {
                    backgroundColor: "#1A1A1A",
                    border: "1px solid #5BF2FF",
                  },
                }}
              >
                Get Started Free
              </Button>
              <Button
                onClick={handleWatchDemo}
                sx={{
                  backgroundColor: "transparent",
                  color: "#FFFFFF",
                  fontWeight: 600,
                  borderRadius: "10px",
                  textTransform: "none",
                  padding: "12px 32px",
                  fontSize: "1rem",
                  fontFamily: "Outfit",
                  border: "1px solid rgba(255, 255, 255, 0.3)",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    border: "1px solid #5BF2FF",
                  },
                }}
              >
                Watch Demo
              </Button>
            </Box> */}

            {/* Trust Indicator */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Box
                sx={{
                  width: "20px",
                  height: "20px",
                  backgroundColor: "#FFD700",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "12px",
                }}
              >
                ★
              </Box>
              <Typography
                sx={{
                  fontSize: "1rem",
                  fontFamily: "Outfit",
                  color: "rgba(255, 255, 255, 0.9)",
                }}
              >
                Trusted by 500+ Dietitians | HIPAA Compliant
              </Typography>
            </Box>
          </Box>

          {/* Right Section - Laptop Mockup */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              minHeight: "400px",
            }}
          >
            {/* Laptop Mockup */}
            <Box
              sx={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <Box
                component="img"
                src={require("assets/images/about2hero.png")}
                alt="Fitify Dashboard"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "10px",
                }}
              />
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default AboutHeroSection;
